import React, { useState } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { FiPlay, FiPause, FiVolume2, FiVolumeX } from 'react-icons/fi';

const AudioPlayer = ({ title, description, audioSrc }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  const handlePlay = () => {
    setIsPlaying(true);
  };

  const handlePause = () => {
    setIsPlaying(false);
  };

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };

  return (
    <div className="audio-player-container">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-3">
        <div>
          <h3 className="text-lg font-medium text-sharon-dark-green">{title}</h3>
          <p className="text-sm text-sharon-gray">{description}</p>
        </div>
        <div className="flex items-center mt-2 md:mt-0">
          <button
            onClick={toggleMute}
            className="mr-2 text-sharon-gray hover:text-sharon-dark-green"
            aria-label={isMuted ? 'Unmute' : 'Mute'}
          >
            {isMuted ? <FiVolumeX size={20} /> : <FiVolume2 size={20} />}
          </button>
          <button
            onClick={isPlaying ? handlePause : handlePlay}
            className="bg-sharon-green hover:bg-sharon-dark-green text-white p-2 rounded transition-colors duration-300"
            aria-label={isPlaying ? 'Pause' : 'Play'}
          >
            {isPlaying ? <FiPause size={16} /> : <FiPlay size={16} />}
          </button>
        </div>
      </div>
      <ReactAudioPlayer
        src={audioSrc}
        autoPlay={false}
        controls={true}
        muted={isMuted}
        onPlay={handlePlay}
        onPause={handlePause}
        style={{ width: '100%' }}
        className="w-full"
      />
    </div>
  );
};

export default AudioPlayer;